<template>
  <div class="sponsors-page">
    <h2 class="section-title">Naši sponzoři</h2>
    
    <div class="row row-cols-1 row-cols-md-2 g-4 mt-4">
      <div v-for="sponsor in sponsors" :key="sponsor.id" class="col">
        <div class="card h-100 custom-card">
          <img v-if="sponsor.logo" :src="sponsor.logo" class="card-img-top" :alt="sponsor.name">
          <div class="card-body">
            <h5 class="card-title">{{ sponsor.name }}</h5>
            <p class="card-text">{{ sponsor.description }}</p>
            <a v-if="sponsor.website" :href="formatWebsite(sponsor.website)" target="_blank" class="btn btn-primary custom-btn">
              Navštívit web
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SponsorsList',
  data() {
    return {
      sponsors: []
    }
  },
  methods: {
    async loadSponsors() {
      try {
        const response = await axios.get('/api/sponsors');
        this.sponsors = response.data;
      } catch (error) {
        console.error('Error loading sponsors:', error);
      }
    },
    formatWebsite(url) {
      if (!url) return '';
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
      }
      return 'https://' + url;
    }
  },
  mounted() {
    this.loadSponsors();
  }
}
</script>

<style scoped>
.sponsors-page {
  max-width: 1200px;
  margin: 0 auto;
  background: #0a1023;
  color: #e0e6f7;
  min-height: 100vh;
  padding: 2rem 1rem 3rem;
}

.section-title {
  background: linear-gradient(135deg, #1fe0ff, #0a7cff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.15;
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
}

.card-img-top {
  height: 200px;
  object-fit: contain;
  padding: 1.5rem;
  background: #151d3a;
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}

.custom-card {
  background: #151d3a;
  color: #e0e6f7;
  border: 1px solid rgba(31, 224, 255, 0.08);
  border-radius: 0.75rem;
  margin-bottom: 2rem;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.custom-card:hover {
  transform: translateY(-4px);
  border-color: rgba(31, 224, 255, 0.2);
  box-shadow: 0 8px 24px rgba(10, 16, 35, 0.4),
              0 0 0 1px rgba(31, 224, 255, 0.05);
}

.card-title {
  color: #e0e6f7;
  font-weight: 700;
  font-size: 1.2rem;
}

.card-text {
  color: #8892b0;
  font-size: 0.95rem;
}

.custom-btn {
  background: linear-gradient(135deg, #1fe0ff 0%, #0a7cff 100%);
  color: #0a1023;
  font-weight: 700;
  border: none;
  border-radius: 0.5rem;
  padding: 0.55rem 1.5rem;
  font-size: 0.95rem;
  box-shadow: 0 2px 8px rgba(31, 224, 255, 0.2);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.custom-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 20px rgba(31, 224, 255, 0.35);
  color: #0a1023;
}
</style> 